export const BRAND_COLORS = {
  blue: "#C6D7DD",
  navy: "#233A56",
  green: "#CADD5A",
  olive: "#5F693A",
  brick: "#533828",
  bark: "#BBA087",
  orange: "#FF993A",
  red: "#B4412D",
};

export type BrandColor = keyof typeof BRAND_COLORS;

export const MONO_COLORS = {
  black: "#26231B",
  white: "#E5E8DB",
};

export type MonoColor = keyof typeof MONO_COLORS;

export type ColorScheme = {
  fg: BrandColor | MonoColor;
  fgColor: string;
  bg: BrandColor | MonoColor;
  bgColor: string;
};

export type AnyColor = BrandColor | MonoColor;

export const ALL_COLORS = {
  ...BRAND_COLORS,
  ...MONO_COLORS,
};

function createScheme(
  bg: BrandColor | MonoColor,
  fg: BrandColor | MonoColor
): ColorScheme {
  return {
    bg,
    bgColor: ALL_COLORS[bg],
    fg,
    fgColor: ALL_COLORS[fg],
  };
}

type SchemePair = {
  default: ColorScheme;
  inverted: ColorScheme;
};

function createSchemePair(
  bg: BrandColor | MonoColor,
  fg: BrandColor | MonoColor,
  bg2 = fg,
  fg2 = bg
): SchemePair {
  return {
    default: createScheme(bg, fg),
    inverted: createScheme(bg2, fg2),
  };
}

export const COLOR_SCHEMES = {
  neutral: createSchemePair("white", "black", "black", "white"),
  blue: createSchemePair("blue", "black"),
  navy: createSchemePair("navy", "white"),
  green: createSchemePair("green", "black"),
  olive: createSchemePair("olive", "white"),
  brick: createSchemePair("brick", "white"),
  bark: createSchemePair("bark", "black"),
  orange: createSchemePair("orange", "black"),
  red: createSchemePair("red", "white", "black", "red"),
} satisfies {
  [K: string]: SchemePair;
};

export type BrandScheme = keyof typeof COLOR_SCHEMES;

export type AnyScheme = BrandScheme | "multicolor";
